// extracted by mini-css-extract-plugin
module.exports = {"bundles":"JPBundle_bundles__S70j8"};